var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"component",staticClass:"slideshow-component"},_vm._l((_vm.images),function(image,index){return _c('figure',{class:{show: index === 0},style:({
      background: ("url(" + (require(("@/assets/" + image))) + ") no-repeat center center"),
      'animation': (_vm.keyframeName + " " + _vm.slideshowDuration + "s linear infinite 0s"),
      'animation-delay': ((index * _vm.period) + "s"),
    })})}))}
var staticRenderFns = []

export { render, staticRenderFns }